module.exports = __webpack_public_path__ + "static/media/alert-edit.c34c323c.svg";